import PointListingTable from './pointListingTable.container'

export default PointListingTable